import React, { useCallback } from 'react';
import styled from 'styled-components';
import CurvyLineImage from 'op/assets/curvy-line.svg';
import { Checkbox } from 'semantic-ui-react';

const CurvyLine = styled.img`
    height: 100%;
    position: relative;
`;

const InlineBlockWithCaption = styled.div`
    display: inline-block;
    position: relative;
    ::before {
        content: attr(data-content);
        position: absolute;
        font-size: 0.8em;
        top: -1.5em;
        width: 100%;
        text-align: center;
    }
`;

const CurvyLineWithCaption = ({ caption, ...props }) => (
    <InlineBlockWithCaption data-content={caption} >
        <CurvyLine {...props} />
    </InlineBlockWithCaption>
);

const RowsBox = styled.div`
    position: relative;
    width: 80%;
    max-width: 300px;
    min-width: 200px;
    aspect-ratio: 1/1;
    margin-top: 1.5em;
    margin-right: 4em;
    display: flex;
    flex-direction: column;
`;

const RowWithCheckboxes = styled.div`
    flex: 1;
    display: flex;
    position: relative;
    justify-content: space-around;
    align-items: center;
    padding-left: 4%;
    padding-right: 4%;
    ::after {
        content: attr(data-content);
        position: absolute;
        font-size: 0.9em;
        font-weight: bold;
        right: -4em;
    }
`;

const RowWithCheckboxesBordered = styled(RowWithCheckboxes)`
    border: 1px solid black;
    border-bottom: none;
    &:last-child {
        border-bottom: 1px solid black;
    }
`;

const LinesHolder = styled.div`
    position: absolute;
    display: flex;
    padding-left: 4%;
    padding-right: 4%;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
`;

const MainBox = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1em;
    width: 100%;
    align-items: center;
`;

const CheckboxOnTop = styled(Checkbox)`
    z-index: 1;
`;


const Test12 = ({ view, setStpForm, id }) => {
    const onChange = useCallback((e, { name, checked }) => {
        setStpForm((prev) => {
            const newStpForm = { ...prev };

            newStpForm.data.forEach((item) => {
                if (item.STPTestView === view.STPTestView) {
                    item[name] = checked;
                }
            });

            return newStpForm;
        });
    }, [view]);

    return (
        <MainBox id={id}>
            <RowsBox>
                <LinesHolder>
                    <CurvyLineWithCaption caption='24 AWG' src={CurvyLineImage} alt="Curvy Line" />
                    <CurvyLineWithCaption caption='30 AWG' src={CurvyLineImage} alt="Curvy Line" />
                    <CurvyLineWithCaption caption='32 AWG' src={CurvyLineImage} alt="Curvy Line" />
                    <CurvyLineWithCaption caption='36 AWG' src={CurvyLineImage} alt="Curvy Line" />
                </LinesHolder>
                <RowWithCheckboxes>
                    <CheckboxOnTop name={`STPTest12_24_0`} onChange={onChange} checked={view.STPTest12_24_0} />
                    <CheckboxOnTop name={`STPTest12_30_0`} onChange={onChange} checked={view.STPTest12_30_0} />
                    <CheckboxOnTop name={`STPTest12_32_0`} onChange={onChange} checked={view.STPTest12_32_0} />
                    <CheckboxOnTop name={`STPTest12_36_0`} onChange={onChange} checked={view.STPTest12_36_0} />
                </RowWithCheckboxes>
                <RowWithCheckboxesBordered data-content='4.8mm'>
                    <CheckboxOnTop name={`STPTest12_24_48`} onChange={onChange} checked={view.STPTest12_24_48} />
                    <CheckboxOnTop name={`STPTest12_30_48`} onChange={onChange} checked={view.STPTest12_30_48} />
                    <CheckboxOnTop name={`STPTest12_32_48`} onChange={onChange} checked={view.STPTest12_32_48} />
                    <CheckboxOnTop name={`STPTest12_36_48`} onChange={onChange} checked={view.STPTest12_36_48} />
                </RowWithCheckboxesBordered>
                <RowWithCheckboxesBordered
                    data-content='7.9mm'
                    style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.2)'
                    }}>
                    <CheckboxOnTop name={`STPTest12_24_79`} onChange={onChange} checked={view.STPTest12_24_79} />
                    <CheckboxOnTop name={`STPTest12_30_79`} onChange={onChange} checked={view.STPTest12_30_79} />
                    <CheckboxOnTop name={`STPTest12_32_79`} onChange={onChange} checked={view.STPTest12_32_79} />
                    <CheckboxOnTop name={`STPTest12_36_79`} onChange={onChange} checked={view.STPTest12_36_79} />
                </RowWithCheckboxesBordered>
                <RowWithCheckboxesBordered data-content='11.1mm' style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)'
                }}>
                    <CheckboxOnTop name={`STPTest12_24_111`} onChange={onChange} checked={view.STPTest12_24_111} />
                    <CheckboxOnTop name={`STPTest12_30_111`} onChange={onChange} checked={view.STPTest12_30_111} />
                    <CheckboxOnTop name={`STPTest12_32_111`} onChange={onChange} checked={view.STPTest12_32_111} />
                    <CheckboxOnTop name={`STPTest12_36_111`} onChange={onChange} checked={view.STPTest12_36_111} />
                </RowWithCheckboxesBordered>
            </RowsBox>
        </MainBox>
    );
}

export default Test12;
